// This optional code is used to register a service worker with Vite PWA
// register() is not called by default.
import { registerSW } from 'virtual:pwa-register';

// This is different from the Create React App service worker implementation
// as it uses Vite's PWA plugin

type Config = {
  onSuccess?: (registration: ServiceWorkerRegistration) => void;
  onUpdate?: (registration: ServiceWorkerRegistration) => void;
};

export function register(config?: Config) {
  if ('serviceWorker' in navigator) {
    // The URL constructor is available in all browsers that support SW.
    const updateSW = registerSW({
      onNeedRefresh() {
        // New content is available; show a notification or refresh the page
        if (config?.onUpdate) {
          navigator.serviceWorker.getRegistration().then((registration) => {
            if (registration) {
              config.onUpdate?.(registration);
            }
          });
        } else {
          // Replace confirm with a custom modal or notification system
          const userConfirmed = window.confirm('New content available. Reload the app?');
          if (userConfirmed) {
            updateSW(true);
          }
        }
      },
      onOfflineReady() {
        // Content has been cached for offline use
        console.log('Content is cached for offline use.');
        if (config?.onSuccess) {
          navigator.serviceWorker.getRegistration().then((registration) => {
            if (registration) {
              config.onSuccess?.(registration);
            }
          });
        }
      },
    });
  }
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => {
        registration.unregister();
      })
      .catch((error) => {
        console.error(error.message);
      });
  }
}
